import dayjs from 'dayjs';
import { parse, toSeconds } from 'iso8601-duration';

const ISO_DURATION_REFERENCE_DATE = new Date(0);

export const parseDateTime = (dateTime: string | dayjs.Dayjs) => dayjs(dateTime).format('h:mm a');

export const getTimeRange = (startTime?: string, endTime?: string): string => {
  if (startTime && endTime) {
    return `${parseDateTime(startTime)} - ${parseDateTime(endTime)}`;
  }
  return '';
};

export const isoTimeToSeconds = (time: string) =>
  time ? toSeconds(parse(time), ISO_DURATION_REFERENCE_DATE) : -1;

export const secondsToIsoTime = (seconds: number): string => {
  if (seconds < 0 || Number.isNaN(seconds)) return 'PT0S';
  const hours = Math.floor(seconds / 3600);
  const remainder = seconds % 3600;
  const minutes = Math.floor(remainder / 60);
  const remainingSeconds = remainder % 60;
  let isoString = 'PT';
  if (hours > 0) isoString += `${hours}H`;
  if (minutes > 0) isoString += `${minutes}M`;
  const decimalPlaces = remainingSeconds % 1 !== 0 ? 1 : 0;
  if (remainingSeconds > 0 || isoString === 'PT')
    isoString += `${remainingSeconds.toFixed(decimalPlaces)}S`;
  return isoString;
};
